/* global confirm */

/**
 * Class for handling all custom functionality on view order page (/my-account/view-order/123/)
 */
export class ViewOrdersTable {
	constructor( element ) {
		this.element = element;

		this.deleteOrderButtons = this.element.querySelectorAll( '.qala-b2b-delete-order' );
	}

	/**
	 * Initialize the view order page with all needed callbacks
	 *
	 * @return {void}
	 */
	init() {
		this.addConfirmationToDeleteOrders( this.deleteOrderButtons );
	}

	/**
	 * Add confirmation dialog to delete orders.
	 *
	 * @param {NodeList} deleteOrderButtons
	 * @return {void}
	 */
	addConfirmationToDeleteOrders( deleteOrderButtons ) {
		deleteOrderButtons.forEach( element => {
			element.addEventListener( 'click', this.deleteOrderButtonClickHandler.bind( this ) );
		} );
	}

	/**
	 * Delete order button click handler.
	 *
	 * @param {Event} event
	 * @return {void}
	 */
	deleteOrderButtonClickHandler( event ) {
		const confirmation = confirm( window.QalaB2bWholesale.translations.orderPageTranslations.deleteOrderConfirmation ); // eslint-disable-line no-alert

		if ( ! confirmation ) {
			event.preventDefault();
		}
	}
}
